// extracted by mini-css-extract-plugin
export default {"heroSection":"HeroSearchSection_heroSection__sBN1u","heroSearch":"HeroSearchSection_heroSearch__cMRIJ","heroGradientShift":"HeroSearchSection_heroGradientShift__WY0cW"};